import { defineMessages } from 'react-intl-next';

export const messages: {
	aupViolation: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	generalError: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	notEnoughContent: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	rateLimit: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	tooMuchContent: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	generalError: {
		id: 'company-hub-common.ai.error.common-error.general-error',
		defaultMessage:
			'Atlassian Intelligence can’t provide a response right now. Read more <a>in our support documentation</a>.',
		description: 'general error message when quick summary fails',
	},
	notEnoughContent: {
		id: 'company-hub-common.ai.error.common-error.not-enough-content',
		defaultMessage:
			'There isn’t enough content here to summarize. Try again when more content has been added.',
		description: 'error message when there is not enough content to summarize',
	},
	rateLimit: {
		id: 'company-hub-common.ai.error.common-error.rate-limit',
		defaultMessage:
			'Excessive use has been detected with Atlassian Intelligence. Try again later. Read more <a>in our support documentation</a>.',
		description: 'error message when the user has hit the rate limit of quick summary',
	},
	tooMuchContent: {
		id: 'company-hub-common.ai.error.page-error.too-much-content',
		defaultMessage:
			'Atlassian Intelligence can’t generate a summary for you right now, as there is too much content to summarize.',
		description: 'error message when there is too much content to summarize',
	},
	aupViolation: {
		id: 'company-hub-common.ai.error.page-error.aup-violation',
		defaultMessage:
			'Your content might not comply with our Acceptable Use Policy. Please review and refer to our <a>Acceptable Use Policy</a> if needed.',
		description: "error message when the content fails Atlassian's acceptable use policy",
	},
});
